import styled from '@emotion/styled';
import { themeVars } from '@eds-web/react';
import { device } from '../../constants/breakpoint';

export const StyledGatedContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 32px;
    margin: 64px auto;
    padding: 32px;
    width: 560px;
    background-color: ${themeVars.color.background.elevated.low};
    border-radius: 24px;
    border: solid 1px ${themeVars.color.transparent.light['015']};
    @media screen and ${device.laptop} {
        max-width: 90%;
        box-sizing: border-box;
    }

    a {
        color: ${themeVars.color.palette.blue['500']};
    }

    .alert-icon {
        display: flex;
        justify-content: center;
    }
    .minor-content {
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        gap: 8px;
    }

    .selection-form {
        display: flex;
        gap: 24px;
        .selection-form-container {
            display: flex;
            align-items: flex-end;
            width: 100%;
            & > div {
                flex: 1;
                margin-right: 20px;
            }
            @media screen and ${device.laptop} {
                display: block;
                box-sizing: border-box;
                & > div {
                    margin-bottom: 24px;
                    margin-right: 0;
                }
            }
        }
    }

    .button-action {
        display: flex;
        button {
            flex: 1;
            margin-right: 20px;
        }
        @media screen and ${device.laptop} {
            button {
                margin-bottom: 24px;
                margin-right: 0;
            }
        }
    }
`;

export const StyledErrorContent = styled(StyledGatedContent)`
    display: flex;
    flex-direction: column;
    gap: 32px;
    margin: 64px auto;
    padding: 32px;
    width: 560px;
    background-color: ${themeVars.color.background.elevated.low};
    border-radius: 24px;
    border: solid 1px ${themeVars.color.transparent.light['015']};
    text-align: center;
`;
